module.exports = __webpack_public_path__ + "assets/69c336b603dd18abd977acadd4a4c503.png";